<script>
	export let active;
	export let imgCount;
	export let interaction;

	$: pos = (active / imgCount) * 100;
</script>

<div class="slide">
	<input
		type="range"
		name="slide"
		id="slide"
		bind:value={active}
		min="0"
		max={imgCount}
		on:input={() => {
			interaction = true;
		}}
	/>
	<div class="mask">
		<div class="markMarker" style="left: {pos}%" />
	</div>
</div>

<style>
	.slide {
		width: 100%;
		height: 20px;
		position: relative;
		overflow: visible;
		align-self: center;
	}
	#slide {
		width: 80%;
		z-index: 99;
		display: block;
		margin: 0 auto;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 10%;
		opacity: 0;
		cursor: pointer;
	}
	.mask {
		width: 78%;
		height: 6px;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 11%;
		z-index: 1000;
		background: rgba(0, 0, 0);
		overflow: visible;
		pointer-events: none;
	}
	.markMarker {
		width: 6px;
		height: 24px;
		border-radius: 3px;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		background: #ed6442;
		z-index: 1001;
	}
</style>
